import { render, staticRenderFns } from "./StockItemForm.vue?vue&type=template&id=2004c3be&"
import script from "./StockItemForm.vue?vue&type=script&lang=js&"
export * from "./StockItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports